import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import landarea from "../images/land area airport kolkta.jpg";


function Plot() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="Gray" />
            <div className='balajisareeblog'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/blog" href="#">All Blog</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Unicorn Aerocity Blog</li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <br />


                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">

                                <h1 className='linetext'><b style={{ color: "#EE1F25" }}>Unicorn Aero Greens </b> – Premium Plots Near Kolkata Airport</h1>
                                <p className='mb-2' style={{ color: "maroon" }}>Unicorn Aero Greens, Prime Location Advantage</p>

                                <p className='websitedevelopment' style={{ color: "maroon" }}><small>Unicorn Aerocity is located in close proximity to Kolkata Airport, making it an ideal choice for both end-users and investors.</small></p>
                                <h5 className='websitedevelopment mb-2' style={{color:"maroon"}}>High Growth Potential</h5>
                        <p>With continuous infrastructure development, property prices in this zone are expected to rise significantly.</p>
                        <h5 className='websitedevelopment mb-2'style={{color:"maroon"}}>Freedom to Build</h5>
                        <h5 className='websitedevelopment mb-3'>Unlike apartments, plots give you complete flexibility to design and construct your dream home.</h5>
                            </div>

                            <div className="col-md-5">
                                <img className="card-img-top" src={landarea} alt="landarea" />

                            </div>
                        </div>
<br/>
                        
                        <h5 className='websitedevelopment'><b>Investment Benefits
📈 High appreciation due to location advantage
🛣️ Excellent connectivity to major hubs
🏙️ Near fast-developing IT & commercial zones
🏡 Ideal for future home construction</b></h5>

                        
                    </div>
                </div>

                <br />
            </div>


        </div>
    )
}

export default Plot